 // @ts-nocheck
import React from 'react';
import cx from 'classnames';
import imageNotAvailable from '@icons/car-search-large.png';
import './FilterImageCheckbox.scss';

export type FilterImageCheckboxProps = {
  className?: string;
  check: boolean;
  src?: string;
  label?: string;
  value?: string | number;
  onCheck?: (
    param: string | number,
    event: React.MouseEvent<HTMLDivElement>
  ) => void;
  error?: string;
  hint?: string | number;
  disabled?: boolean;
  alwaysEnabled?: boolean;
  isLeftAligned?: boolean;
  title?: string;
  withImage?: boolean;
};

export const FilterImageCheckbox = ({
  check,
  className,
  disabled = false,
  error,
  hint,
  label,
  title,
  onCheck = () => null,
  src,
  value = '',
  alwaysEnabled = false,
  isLeftAligned,
  withImage
}: FilterImageCheckboxProps) => (
  <div
    className={cx('awc-image-checkbox image-checkbox-container', className, {
      'is-disabled': alwaysEnabled ? false : disabled
    })}
    onClick={(event: React.MouseEvent<HTMLDivElement>) => {
      event.persist();
      onCheck(value, event);
    }}
    role="button"
    title={title}
    tabIndex={0}
    data-testid={label}
  >
    {withImage && (
      <img
        className="image-checkbox-image"
        src={src}
        alt={label}
        onError={e => {
          e.currentTarget.src = imageNotAvailable;
          e.currentTarget.alt = 'no image available';
        }}
      />
    )}
    <div
      className={cx('image-checkbox-row', {
        'is-left-aligned': isLeftAligned
      })}
    >
      <div
        className={cx('image-checkbox-box', {
          'is-checked': check,
          'has-error': Boolean(error)
        })}
        // TODO: check dom attribute. it should be "checked", not "check"
      />

      <div className="image-checkbox-column">
        <span className="image-checkbox-label">{label}</span>
        {hint ? (
          <span className="image-checkbox-hint">({hint})</span>
        ) : (
          <span className="image-checkbox-hint"> </span>
        )}
      </div>
    </div>
  </div>
);
